export const DEFAULT_SALES_SUPPORT_STATE = {
  contacts: [],
  messages: [],
  callStatus: 'idle',
  activeCall: null,
  allotedAgent: {
    mob: null,
    displayName: '',
    agentId: '',
    role: '',
  },
  chatId: null,
  user: {},
  loading: false,
  isImageSelect: false,
  isProductSelect: false,
  isFileSelect: false,
  image: null,
  isVideoSelect: false,
  isRecAudioSelect: false,
  video: null,
  agentSearchItem: null,
  forwardModalAgentSearchItem: null,
  document: [],
  fileSending: false,
  isUserSelected: false,
  ticketStatusFilter: '',
  forwardModalTicketStatusFilter: '',
  showQuickNotes: false,
  filesLength: 0,
  filesLengthWarning: false,
  quickNotes: [],
  forwardMessagesFlag: false,
  forwardMessages: {},
  selectedForwardMessagesContent: [],
  clickedForwardFirstMessageId: null,
  replyMessage: false,
  messageForReply: {},
  repliedMessageFlag: false,
  files: [],
  uploadlock: false,
  selectedAgent: null,
  agentChatStatus: 'all',
  hasMore: true,
  blockedUsers: [],
  blockedUsersCursor: {
    before: null,
    after: null,
  },
};
